import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
  DataService,
  ErrorService,
  LoggerService,
  PageReloadService,
} from '@scientificnet/cockpit-core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  title = 'Cockpit Home';

  constructor(
    private errorSvc: ErrorService,
    private reloadSvc: PageReloadService,
    private logger: LoggerService,
    private dataSvc: DataService
  ) {
    console.log('%cRunning version: ' + environment.version, ' color: #0000FF');
    this.logger.logTrace('AppComponent', {
      method: 'Constructor',
      ua: navigator.userAgent,
      cachedata: localStorage,
    });
  }

  ngOnInit() {
    this.errorSvc.errorNotifier$.subscribe((x) => {
      // Fix: workaround multiple_matching_tokens for core versions <=9.5.4
      this.logger.logEvent('AppComponent', {
        method: 'NgOnInit',
        ua: navigator.userAgent,
        cachedata: localStorage,
        error_data: x,
      });
    });
  }
}
